import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { LoftSummaryReport } from './Pages';

export const LoftSummaryReportRoutes = ({ match }) => (
    <Fragment>
        <Route exact path = {`${match.path}`} component={LoftSummaryReport} />
    </Fragment>
)